import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticatedComponent } from 'app/shared/layout/authenticated/authenticated.component';
import { AuthGuard } from 'app/shared/guards/auth.guard';
import { ListSubscriptionsComponent } from './list-subscriptions/list-subscriptions.component';
import { EditSubscriptionComponent } from './edit-subscription/edit-subscription.component';
import { ShowSubscriptionComponent } from './show-subscription/show-subscription.component';

const routes: Routes = [
  {
    path: '',
    component: AuthenticatedComponent,
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        component: ListSubscriptionsComponent,
      },
      {
        path: ':id/edit',
        canActivate: [AuthGuard],
        component: EditSubscriptionComponent,
        data: {
          state: 'edit',
        },
      },
      {
        path: 'new',
        canActivate: [AuthGuard],
        component: EditSubscriptionComponent,
        data: {
          state: 'new',
        },
      },
      {
        path: ':id/view',
        canActivate: [AuthGuard],
        component: ShowSubscriptionComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SubscriptionsRoutingModule {}
